<div class="browser" *ngIf="this.informacion != null">
  <div class="browser-elements">
    <img class="data" src="{{informacion.primerPromocion}}" alt="">
    <img class="data" src="{{informacion.segundaPromocion}}" alt="">
    <img class="data" src="{{informacion.tercerPromocion}}" alt="">
  </div>
</div>
